export interface EnergyUsagePurposeOption {
  name: string;
  label: string;
  value: string;
}

export interface EnergyUsagePurposeList {
  value: {
    label: string;
    options: EnergyUsagePurposeOption[];
  };
}

export const getDefaultEnergyUsagePurposeList = (): EnergyUsagePurposeList => ({
  value: {
    label: 'Mijn energieafname is voor...',
    options: [
      {
        name: 'business',
        label: 'Zakelijk',
        value: 'business',
      },
      {
        name: 'household',
        label: 'Huishouden',
        value: 'household',
      },
    ],
  },
});
